import { Injectable } from '@angular/core';
import {
  type CanActivate,
  Router,
} from '@angular/router';
import { CognitoService } from './cognito-service';
import { ElevatedMfaService } from './elevated-mfa.service';

@Injectable()
export class ElevatedMfaGuardService implements CanActivate {
  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    private elevatedMfaService: ElevatedMfaService
  ) {}

  // Stub Guard Implementation for Elevated MFA
  canActivate(): boolean {
    // 1. Must be logged in
    if (!this.cognitoService.userLoggedIn()) {
      this.router.navigate(['/authentication/login']);
      return false;
    }

    return true;
  }
}